/* @ngInject */

export default (
  $rootScope,
  dateTimeService,
  SecurityDetails,
  HomeLoanSearchProduct,
  ReviewProduct,
  CompareProduct,
  SwitchProduct,
  FundingWorksheet,
  RefinanceAnalysis,
  HomeLoanCompliance,
  NeedsAnalysis,
  DocType
) => {
  /*
   * Constructor
   * --------------------------------------------------------------------------------
   */
  function HomeLoan(
    id,
    idTicket,
    idOwner,
    idLenderApplication,
    securityDetails,
    reviewProducts,
    compareProducts,
    switchProducts,
    fundingWorksheets,
    maximumBorrowing,
    searchFields,
    commission,
    refinanceAnalysis,
    compliance,
    needsAnalysis,
    summary,
    timeStamp,
    isActive
  ) {
    this.id = id;
    this.docType = DocType.of('__datum.loan');
    this.idTicket = idTicket;
    this.idOwner = idOwner;
    this.idLenderApplication = idLenderApplication;
    this.securityDetails = securityDetails;
    this.reviewProducts = reviewProducts;
    this.compareProducts = compareProducts;
    this.switchProducts = switchProducts;
    this.fundingWorksheets = fundingWorksheets;
    this.maximumBorrowing = maximumBorrowing;
    this.searchFields = searchFields;
    this.commission = commission;
    this.refinanceAnalysis = refinanceAnalysis;
    this.compliance = compliance;
    this.needsAnalysis = needsAnalysis;
    this.summary = summary;
    this.timeStamp = timeStamp;
    this.isActive = isActive;
  }

  /*
   * Static methods
   * --------------------------------------------------------------------------------
   */
  HomeLoan.blank = function () {
    return HomeLoan.build({
      id: '',
      idTicket: '',
      idOwner: '',
      idLenderApplication: '',
      securityDetails: {},
      reviewProducts: [],
      compareProducts: [],
      switchProducts: {},
      fundingWorksheets: {},
      maximumBorrowing: {
        expectedRate: 0,
        idLenders: []
      },
      searchFields: {},
      commission: {
        idCommission: '',
        commissionSplits: [],
        isEdited: false
      },
      refinanceAnalysis: {},
      compliance: {},
      needsAnalysis: {},
      summary: {
        financialPosition: {
          netIncomeComments: '',
          currentRepaymentComments: '',
          proposedRepaymentComments: '',
          currentExpensesComments: ''
        }
      },
      timeStamp: dateTimeService.epoch(),
      isActive: true
    });
  };
  HomeLoan.build = function (data) {
    return new HomeLoan(
      data.id,
      data.idTicket ? data.idTicket : '',
      data.idOwner ? data.idOwner : '',
      data.idLenderApplication ? data.idLenderApplication : '',
      _.isEmpty(data.securityDetails)
        ? SecurityDetails.Blank()
        : SecurityDetails.Build(data.securityDetails),
      _.map(_.compact(data.reviewProducts), (reviewProduct) =>
        ReviewProduct.Build(reviewProduct)
      ),
      _.map(_.compact(data.compareProducts), (compareProduct) =>
        CompareProduct.Build(compareProduct)
      ),
      _.isEmpty(data.switchProducts)
        ? SwitchProduct.Blank()
        : SwitchProduct.Build(data.switchProducts),
      _.isEmpty(data.fundingWorksheets)
        ? FundingWorksheet.Blank()
        : FundingWorksheet.Build(data.fundingWorksheets),
      data.maximumBorrowing
        ? data.maximumBorrowing
        : {
            expectedRate: 0,
            idLenders: []
          },
      _.isEmpty(data.searchFields)
        ? HomeLoanSearchProduct.Blank()
        : HomeLoanSearchProduct.Build(data.searchFields),
      data.commission
        ? data.commission
        : {
            idCommission: '',
            commissionSplits: [],
            isEdited: false
          },
      _.isEmpty(data.refinanceAnalysis)
        ? RefinanceAnalysis.Blank()
        : RefinanceAnalysis.Build(data.refinanceAnalysis),
      _.isEmpty(data.compliance)
        ? HomeLoanCompliance.Blank()
        : HomeLoanCompliance.Build(data.compliance),
      _.isEmpty(data.needsAnalysis)
        ? NeedsAnalysis.Blank()
        : NeedsAnalysis.Build(data.needsAnalysis),
      data.summary
        ? data.summary
        : {
            financialPosition: {
              netIncomeComments: '',
              currentRepaymentComments: '',
              proposedRepaymentComments: '',
              currentExpensesComments: ''
            }
          },
      data.timeStamp ? data.timeStamp : dateTimeService.epoch(),
      data.isActive ? data.isActive : true
    );
  };

  /*
   * Public methods
   * --------------------------------------------------------------------------------
   */
  HomeLoan.prototype.getBaseLvr = function () {
    return `${Math.round(this.fundingWorksheets.fundsAvailable.baseLvr).toFixed(0)}%`;
  };
  HomeLoan.prototype.getDate = function (timeZone, format) {
    return moment
      .utc(this.timeStamp, 'X')
      .tz(timeZone || 'UTC')
      .format(format || 'LL');
  };
  HomeLoan.prototype.getTime = function (timeZone, format) {
    return moment
      .utc(this.timeStamp, 'X')
      .tz(timeZone || 'UTC')
      .format(format || 'LTS');
  };
  HomeLoan.prototype.deleteDateObject = function () {
    for (let f = 0; f < this.fundingWorksheets.fundsRequired.length; f += 1) {
      delete this.fundingWorksheets.fundsRequired[f].contractDateObject;
    }
    for (let a = 0; a < this.compliance.verifications.applicants.length; a += 1) {
      delete this.compliance.verifications.applicants[a].dateVerifiedObject;
    }
    delete this.compliance.verifications.interviewDetailsDateVerifiedObject;
    delete this.compliance.verifications.antiMoneyLaunderingChecksCompletedDateVerifiedObject;
    delete this.compliance.verifications.creditChecksCompletedDateVerifiedObject;
    delete this.compliance.verifications.propertySearchesCompletedDateVerifiedObject;
    delete this.compliance.verifications.incomeVerificationCompletedDateVerifiedObject;
    delete this.compliance.verifications.livingExpensesVerifiedDateVerifiedObject;
  };

  return HomeLoan;
};
